module.exports = __webpack_public_path__ + "img/icon-white.5243ff5.png";